import React from 'react';
import { ArrowRightIcon } from 'icons';
import Link from 'next/link';
import { useTranslations } from 'next-intl';

import { ICourse } from 'modules/courses';
import { globalConst } from 'modules/global';

import CourseCard from './course-card';

interface IProps {
  recommendedCourses?: ICourse[];
}

const CourseRecommendation: React.FC<IProps> = ({ recommendedCourses }) => {
  const t = useTranslations();

  return (
    <div className="rounded-xl bg-white p-4">
      <div className="flex items-center justify-between">
        <p className="font-medium">{t("tavsiya_etiladigon_kurslar")}</p>
        <Link
          href={`${globalConst.pageNames?.COURSES_FILTER}`}
          className="flex items-center gap-2 text-sm font-medium text-green-500 hover:underline"
        >
          {t('barchasi')} <ArrowRightIcon />
        </Link>
      </div>
      <div className="mt-3 space-y-2">
        {recommendedCourses?.map(course => <CourseCard key={course?.id} course={course} />)}
      </div>
    </div>
  );
};

export default CourseRecommendation;
